import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoProfileComponent } from './photo-profile.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [PhotoProfileComponent],
  exports: [PhotoProfileComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule]
})
export class PhotoProfileModule {}
